import { apiFetch } from './client';

export const COUPON_VALIDATION_ERRORS = {
  coupon_code_required: 'Enter a coupon code.',
  coupon_not_found: 'This coupon code does not exist.',
  coupon_not_started: 'This coupon is not active yet.',
  coupon_expired: 'This coupon has expired.',
  min_order_not_met: 'Order subtotal is below this coupon’s minimum.',
  coupon_exhausted: 'This coupon has reached its total redemption limit.',
  coupon_user_limit: 'This customer has already used this coupon the maximum number of times.',
};

export function normalizeCoupon(raw) {
  const coupon = raw?.promotion || raw || {};
  return {
    code: coupon.code || '',
    discountType: coupon.discount_type || 'FIXED',
    discountValue: coupon.discount_value ?? 0,
    minOrderAmount: coupon.min_order_amount ?? 0,
    maxRedemptionsGlobal: coupon.max_redemptions_global ?? null,
    maxRedemptionsPerUser: coupon.max_redemptions_per_user ?? null,
    startsAt: coupon.starts_at || null,
    endsAt: coupon.ends_at || null,
    status: coupon.status || 'ACTIVE',
    stackable: !!coupon.stackable,
  };
}

function toPayload(data) {
  const payload = {
    code: data.code ? data.code.toUpperCase() : undefined,
    discount_type: data.discountType || undefined,
    discount_value: data.discountValue !== undefined && data.discountValue !== '' ? Number(data.discountValue) : undefined,
    min_order_amount: data.minOrderAmount !== undefined && data.minOrderAmount !== '' ? Number(data.minOrderAmount) : undefined,
    max_redemptions_global: data.maxRedemptionsGlobal !== undefined && data.maxRedemptionsGlobal !== '' && data.maxRedemptionsGlobal !== null
      ? Number(data.maxRedemptionsGlobal) : undefined,
    max_redemptions_per_user: data.maxRedemptionsPerUser !== undefined && data.maxRedemptionsPerUser !== '' && data.maxRedemptionsPerUser !== null
      ? Number(data.maxRedemptionsPerUser) : undefined,
    starts_at: data.startsAt || undefined,
    ends_at: data.endsAt || undefined,
    status: data.status || undefined,
    stackable: !!data.stackable,
  };
  Object.keys(payload).forEach((key) => payload[key] === undefined && delete payload[key]);
  return payload;
}

export async function listActivePromotions() {
  const raw = await apiFetch('/promotions');
  return (raw?.promotions || []).map(normalizeCoupon);
}

export async function listAllPromotions(token, status) {
  const query = status ? `?status=${encodeURIComponent(status)}` : '';
  const raw = await apiFetch(`/store/promotions${query}`, { token });
  return (raw?.promotions || []).map(normalizeCoupon);
}

export async function validateCoupon({ couponCode, subtotal }, token) {
  const raw = await apiFetch('/promotions/validate', {
    method: 'POST',
    token,
    body: { coupon_code: couponCode, subtotal },
  });
  return {
    valid: !!raw.valid,
    couponCode: raw.coupon_code,
    discountAmount: raw.discount_amount ?? 0,
    discountPercent: raw.discount_percent ?? (raw.discount_type === 'PERCENT' ? raw.discount_value : undefined),
    discountType: raw.discount_type,
    discountValue: raw.discount_value,
    totalAfterDiscount: raw.total_after_discount ?? subtotal,
  };
}

export async function createCoupon(data, token) {
  const raw = await apiFetch('/promotions', { method: 'POST', token, body: toPayload(data) });
  return normalizeCoupon(raw);
}

export async function updateCoupon(code, data, token) {
  const raw = await apiFetch(`/promotions/${encodeURIComponent(code)}`, { method: 'PUT', token, body: toPayload(data) });
  return normalizeCoupon(raw);
}
